import { render } from "./FIT.vue?vue&type=template&id=4bd47465&scoped=true"
import script from "./FIT.vue?vue&type=script&lang=js"
export * from "./FIT.vue?vue&type=script&lang=js"

import "./FIT.vue?vue&type=style&index=0&id=4bd47465&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bd47465"]])

export default __exports__